/* Pfand-Abgleich im Warenkorb (VitaminVersand24)
   Hält die Menge der Pfand-Produkte automatisch gleich der Menge pfandpflichtiger Artikel.
   Zuordnung kommt aus snippets/pfand-map.liquid (window.VV24_PFAND.map: Produkt-ID -> Pfand-Variante).
   Funktioniert mit dem UpCart-Drawer (upcartSubscribe…/upcartRefreshCart), dem Theme-Drawer (cart:change/cart:refresh)
   und jeder anderen Warenkorb-Änderung per fetch (/cart/add, /cart/change, /cart/update, /cart/clear). */
(() => {
  const map = (window.VV24_PFAND && window.VV24_PFAND.map) || {};
  const pfandIds = new Set(Object.values(map).map(String));
  if (!pfandIds.size) return;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const isCartPage = () => window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType === 'cart';
  let busy = false;
  let again = false;
  const OWN = 'x-vv24-pfand';
  const nativeFetch = window.fetch.bind(window);

  const soll = (cart) => {
    const need = {};
    pfandIds.forEach((id) => { need[id] = 0; });
    cart.items.forEach((item) => {
      const pf = map[String(item.product_id)];
      if (pf) need[String(pf)] += item.quantity;
    });
    return need;
  };

  const ist = (cart) => {
    const cur = {};
    cart.items.forEach((item) => {
      const v = String(item.variant_id);
      if (pfandIds.has(v)) cur[v] = (cur[v] || 0) + item.quantity;
    });
    return cur;
  };

  const passt = (cart) => {
    const need = soll(cart);
    const cur = ist(cart);
    return Object.keys(need).every((id) => (cur[id] || 0) === need[id]);
  };

  async function sync(cart) {
    if (busy) { again = true; return; }
    busy = true;
    try {
      if (!cart || !Array.isArray(cart.items)) {
        cart = await (await nativeFetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      }
      const need = soll(cart);
      const cur = ist(cart);
      const updates = {};
      Object.keys(need).forEach((id) => { if ((cur[id] || 0) !== need[id]) updates[id] = need[id]; });
      if (!Object.keys(updates).length) return;

      const res = await nativeFetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', [OWN]: '1' },
        body: JSON.stringify({ updates })
      });
      if (!res.ok) { console.warn('Pfand: Warenkorb konnte nicht angepasst werden', res.status); return; }
      const neu = await res.json();
      if (!passt(neu)) { console.warn('Pfand: Pfand-Produkt nicht verfügbar? Bitte prüfen.'); return; }

      if (isCartPage()) { window.location.reload(); return; }
      if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (err) {
      console.warn('Pfand-Abgleich', err);
    } finally {
      busy = false;
      if (again) { again = false; sync(); }
    }
  }

  // Theme-Drawer
  document.addEventListener('cart:change', (e) => sync(e.detail && e.detail.cart));

  // Jede Warenkorb-Änderung per fetch (UpCart, Quick-Add, Apps) – eigene Anfragen ausgenommen
  const MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const headers = (init && init.headers) || {};
    const eigen = headers[OWN] || (typeof headers.get === 'function' && headers.get(OWN));
    const p = nativeFetch(input, init);
    if (!eigen && MUTATION.test(url)) {
      p.then(() => setTimeout(() => sync(), 150)).catch(() => {});
    }
    return p;
  };

  // UpCart-Ereignisse (Funktionen stehen erst bereit, wenn UpCart geladen ist)
  let tries = 0;
  const hookUpcart = () => {
    if (typeof window.upcartSubscribeCartUpdated === 'function') {
      window.upcartSubscribeCartUpdated(() => sync());
      if (typeof window.upcartSubscribeItemRemoved === 'function') window.upcartSubscribeItemRemoved(() => sync());
      if (typeof window.upcartSubscribeAddedToCart === 'function') window.upcartSubscribeAddedToCart(() => sync());
      return;
    }
    if (++tries < 40) setTimeout(hookUpcart, 250);
  };
  hookUpcart();
  window.addEventListener('pageshow', (e) => { if (e.persisted) sync(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => sync());
  else sync();
})();
